import PeopleDataGrid from './PeopleDataGrid'
export default PeopleDataGrid
